import { getMessages } from 'app/store/constants';

export const TOOLTIP_HELP = getMessages().getText('common.help');
